import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from "./modalDataService";
import * as ruleService from "../../rules/ruleService";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";

function MsbConfigField({ msbId, deviceTypeId, msbList, disabled }) {

    useEffect(() => {
        deviceTypeId && ruleService.msbListByDeviceTypeId(deviceTypeId).then(data => 
            !msbId 
            && data
            && data.length > 0
            && modalDataService.changeMsb(data[0].id)            
        )
    }, [deviceTypeId, msbId])

    const onChange = (id) => {
        modalDataService.changeMsb(id);
    }

    const msbListCopy = sortObjectsByAlphabet(msbList || [], 'name');
    const msbOptions = msbListCopy.map((msb) => ({
        value: msb.id,
        label: msb.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="msb">Minimum Security Baseline <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="msb"
                    value={msbId}
                    onChange={onChange}
                    options={msbOptions}
                    isDisabled={disabled || msbOptions.length === 0}
                    placeholder="Select MSB"
                    noOptionsMessage={() => "No MSBs found"}
                />
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    debug("MsbConfigField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        msbList: addDeviceModal.msbList || [],
        msbId: addDeviceModal.msbId,
        deviceTypeId: addDeviceModal.deviceTypeId
    };
}

export default connect(mapStateToProps)(MsbConfigField);
